import { gql } from "@apollo/client";

const QUERY_CHARITY = gql`
  query CharitySearch($search: String) {
    charitySearch(search: $search) {
      _id
      friendlyId
      address {
        city
        country
        state
      }
      entityName
      entityType
      charityType
      complianceLane
      complianceFeeAmount
      complianceReason
      ein
      highlights
      score
      increase {
        achTransfers
        wireTransfers
      }
    }
  }
`;

const QUERY_CHARITY_BY_EIN = gql`
  query charitySearchByEin($search: String) {
    charitySearchByEin(search: $search) {
      _id
      friendlyId
      address {
        city
        country
        state
      }
      entityName
      entityType
      charityType
      complianceLane
      complianceFeeAmount
      complianceReason
      ein
      approvedForGranting
    }
  }
`;

const PRODUCT_FAVORITE_CHARITIES = gql`
  query FavoriteCharities($productId: ID!) {
    favoriteCharities(productId: $productId) {
      _id
      friendlyId
      address {
        city
        country
        state
      }
      entityName
      entityType
      charityType
      complianceLane
      complianceFeeAmount
      complianceReason
      ein
      approvedForGranting
      increase {
        achTransfers
        wireTransfers
      }
    }
  }
`;

export { QUERY_CHARITY, QUERY_CHARITY_BY_EIN, PRODUCT_FAVORITE_CHARITIES };
